"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { PendingLabel } from "@/components/ui/pending-label";
import { cn } from "@/lib/utils";
export function SubmitButton(t0) {
  const $ = _c(9);
  const {
    children,
    className,
    pending
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative overflow-hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== pending) {
    t2 = <PendingLabel pending={pending} spinnerClassName="text-white">{children}</PendingLabel>;
    $[2] = children;
    $[3] = pending;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== pending || $[6] !== t1 || $[7] !== t2) {
    t3 = <Button className={t1} disabled={pending} rounded={true} size="lg" type="submit" variant="special">{t2}</Button>;
    $[5] = pending;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}